import type { Settings as LayoutSettings } from '@ant-design/pro-components'
import { SettingDrawer } from '@ant-design/pro-components'
import '@ant-design/v5-patch-for-react-19'
import type { RequestConfig, RunTimeLayoutConfig } from '@umijs/max'
import defaultSettings from '../config/defaultSettings'
import { requestConfig } from './requestConfig'
import { getLoginUser } from '@/services/userController'
import GlobalFooter from '@/components/global-footer'
import RightContent from '@/components/right-content'
import { initConsoleInterceptor } from '@/utils/console-interceptor'

// 初始化 console 拦截器（生产环境禁用 console 输出）
initConsoleInterceptor()

// const isDev = process.env.NODE_ENV === 'development'
const isDev =false

/**
 * @see https://umijs.org/docs/api/runtime-config#getinitialstate
 * */
export async function getInitialState(): Promise<{
    loginUser?: API.UserVO
    settings?: Partial<LayoutSettings>
    loading?: boolean
}> {
    const loginUser = await getLoginUser()
    console.log('loginUser', loginUser)
    return {
        loginUser,
        settings: defaultSettings as Partial<LayoutSettings>,
    }
}

// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: RunTimeLayoutConfig = ({ initialState, setInitialState }) => {
    return {
        ...defaultSettings,
        menuHeaderRender: undefined,
        footerRender: () => <GlobalFooter />,
        rightContentRender: () => <RightContent initialState={initialState} />,
        childrenRender: (children) => {
            return (
                <div style={{ backgroundColor: '#faf9f5', minHeight: '100vh' }}>
                    {children}
                    {isDev && (
                        <SettingDrawer
                            disableUrlParams
                            enableDarkTheme
                            settings={initialState?.settings}
                            onSettingChange={(settings) => {
                                setInitialState((preInitialState) => ({
                                    ...preInitialState,
                                    settings,
                                }))
                            }}
                        />
                    )}
                </div>
            )
        },
    }
}

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request: RequestConfig = {
    ...requestConfig,
}
